import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { SendIcon } from "../../../components/icons";

import { ProductForm } from "../components";
import { useCreateProduct } from "../hooks";

export const CreateProduct: React.FC = () => {
  const navigate = useNavigate();
  const { form, loading, submit } = useCreateProduct({
    defaultValues: {
      name: "",
    },
    onCompleted: (id) => {
      toast.success("La product a été créé avec succès");
      // navigate(`/product/${id}`, {
      //   replace: true,
      // });
    },
    onError: (message) => {
      toast.error(message);
    },
  });

  return (
    <>
      <Header
        title="Channel"
        subtitle="Creer un nouveau Channel"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: "/rooms",
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <ProductForm loading={loading} form={form} submit={submit} />
      </div>
    </>
  );
};
